<template>
  <div class="btn-group clearable-input" :class="{'conditional-show':conditionalShow}">
    <slot></slot>
    <span :class="['inputclear', variant]" @click="clear()" v-if="showClearButton(model)">
      <i class="bi bi-x-circle"></i>
    </span>
  </div>
</template>
<style scoped>
.clearable-input {
  --inputclear-size: 16px;
  --inputclear-bottom: 35%;


}

.sm {
  --inputclear-size: 14px;
  --inputclear-bottom: 35%;
}

.lg {
  --inputclear-size: 18px;
  --inputclear-bottom: 35%;
}

.xl {
  --inputclear-size: 20px;
  --inputclear-bottom: 35%;
}

.clearable-input .inputclear {
  position: absolute;
  right: 5px;
  bottom: var(--inputclear-bottom);
  height: var(--inputclear-size);
  margin: auto;
  font-size: var(--inputclear-size);
  cursor: pointer;
  color: #858585;
}

.conditional-show.clearable-input {
  /* abilita la visualizzazione condizionale dell'elemento figlio ( l'icona per cancellare ) */
  container-type: inline-size;
  width: 100%;
  container-name: clearable-input;
}

@container clearable-input (max-width: 80px) {
  /* nasconde l'icona se dimensione padre < 50px */
  .inputclear {
    display: none;
  }
}


</style>
<script setup lang="ts">
import { isNumeric } from "@/utils";

const model = defineModel()
const emit = defineEmits(["change"])
const props = defineProps({
  variant: {
    type: String,
    default: null,
  },
  defaultNumeric: {
    type: [Number, null],
    default: 0,
  },
  conditionalShow: {
    type: Boolean,
    default: true,
  }
})

function showClearButton(value: unknown) {
  return value !== null && value !== undefined && value !== "" && value !== props.defaultNumeric
}

function clear() {
  if (isNumeric(model.value)) {
    model.value = props.defaultNumeric
  } else {
    model.value = null
  }
  // trigger change event
  emit('change', model.value)
}
</script>